import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';

const posts = [
  { title: "How to Turn Your YouTube Channel Into a Course Business", cat: "Tutorials", time: "5 min read" },
  { title: "The L&D Manager's Guide to AI Content Repurposing", cat: "Industry", time: "8 min read" },
  { title: "ElevenLabs vs Murf vs Resemble: AI Voice Comparison", cat: "Case Studies", time: "6 min read" },
  { title: "5 YouTube Channels That Built $1M+ Course Businesses", cat: "Case Studies", time: "10 min read" },
  { title: "How We Built a 200-Course Library From 3 Years of Webinars", cat: "Industry", time: "7 min read" },
  { title: "Motion Video vs Static Slides: What Performs Better?", cat: "Tutorials", time: "4 min read" }
];

const Blog = () => {
  return (
    <div className="pt-20 pb-32 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <FadeIn className="text-center mb-16">
        <h1 className="text-4xl md:text-6xl font-black mb-6 text-white drop-shadow-[0_2px_20px_rgba(255,255,255,0.2)]">Resources for course creators</h1>
        <div className="flex justify-center gap-4 mt-8 flex-wrap">
          {['All', 'Tutorials', 'Case Studies', 'Industry'].map(tab => (
            <button 
              key={tab} 
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                tab === 'All' 
                  ? 'bg-brand-electric/20 text-brand-electric border-2 border-brand-electric/40 shadow-[0_0_15px_rgba(0,229,255,0.3)]' 
                  : 'text-white/70 hover:text-white border-2 border-brand-border/40 hover:border-brand-electric/30'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20">
        {posts.map((post, idx) => (
          <FadeIn key={idx} delay={idx * 0.1}>
            <div className="glass-card p-6 h-full flex flex-col hover:border-brand-electric/50 transition-all cursor-pointer hover:shadow-[0_0_30px_rgba(0,229,255,0.2)] border-2 border-brand-border/60">
              <div className="mb-4">
                <span className="text-xs font-bold uppercase tracking-wider text-brand-electric bg-brand-electric/10 px-2 py-1 rounded border border-brand-electric/30">
                  {post.cat}
                </span>
              </div>
              <h3 className="text-xl font-bold text-white mb-3 flex-grow">{post.title}</h3>
              <div className="flex items-center justify-between text-sm text-white/60 mt-4 border-t border-brand-border/50 pt-4">
                <span>By VidRevive Team</span>
                <span>{post.time}</span>
              </div>
            </div>
          </FadeIn>
        ))}
      </div>

      <FadeIn className="max-w-xl mx-auto glass-card p-8 text-center text-white border-2 border-brand-electric/30 shadow-[0_0_30px_rgba(0,229,255,0.2)]">
        <h3 className="text-2xl font-bold mb-4">Subscribe for weekly insights</h3>
        <div className="flex gap-2">
          <input 
            type="email" 
            placeholder="Enter your email" 
            className="flex-grow bg-brand-darker border-2 border-brand-border rounded-lg px-4 py-2 text-white focus:outline-none focus:border-brand-electric transition-colors" 
          />
          <button className="btn-primary py-2 px-6">Subscribe</button>
        </div>
      </FadeIn>
    </div>
  );
};

export default Blog;